<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-navigation-drawer v-model="openNewDialog" temporary app right :width="width" overlay-opacity="0.6" stateless>
      <add-edit-mail @closeDialog="closeDialogHandler"></add-edit-mail>
    </v-navigation-drawer>
  </div>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: false,
        addNewRoute: this.openNewHandler,
        list: [],
        loading: true,
        page: 1,
        editProp: 'name',
        editURL: (item) => `mail_configuration/actions/${item.id}`,
        actionsList: [{
          click: (item) => this.deleteHandler(item.id),
          icon: (item) => 'delete',
          is_show: (item) => true
        }]
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.MAIL_CONFIG_INDEX) ? this.$store.state.MAIL_CONFIG_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'mailconfigurations',
      deleteConfirmDialog: false,
      deleteItemId: 0,
      openNewDialog: false,
      height: window.innerHeight - 77,
      width: (window.innerWidth / 100) * 24
    }
  },
  components: {
    DataList,
    AddEditMail: () => import('./Action.vue')
  },
  computed: {
    ...mapState(['MAIL_CONFIG_INDEX']),
    headers () {
      return [{
        text: this.$t('message.mailConfiguration.name'),
        value: 'name',
        width: '15%'
      }, {
        text: this.$t('message.mailConfiguration.username'),
        value: 'username',
        width: '15%'
      }, {
        text: this.$t('message.mailConfiguration.dosync'),
        value: 'dosync',
        isBoolean: true,
        sortable: false,
        width: '5%'
      }, {
        text: this.$t('message.mailConfiguration.syncfrom'),
        value: 'syncfrom',
        width: '15%'
      }, {
        text: this.$t('message.mailConfiguration.action'),
        value: 'actions',
        width: '5%'
      }]
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'MAIL_CONFIG_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      let fields = this.$formatter.cloneVariable(this.headers)
      const actionCol = fields.findIndex(x => x.value === 'actions')
      if (actionCol > 0) fields.splice(actionCol, 1)
      let queryFields = fields
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let result = queryFields.find(x => x.value === sortBy[0])
      let pageVal = page || 1
      let query = {
        'order_by': {
          'field': result ? result.value : '',
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((response) => {
          let { values, count } = response.data
          for (var i in values) {
            values[i].syncfrom = this.$formatter.formatDate(values[i].syncfrom, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
            values[i].lastsynced = this.$formatter.formatDate(values[i].lastsynced, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
          }
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
        })
    },
    deleteHandler (id) {
      let payload = { url: `${this.MODULE}/${id}`, module: this.MODULE, isSingle: true }
      this.$store.commit('showDeleteDialog', payload)
    },
    openNewHandler () {
      this.openNewDialog = true
    },
    closeDialogHandler () {
      this.openNewDialog = false
      this.getListHandler()
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
